export const externalApplicationRedirectTypes = {
  openInNewTab: 'openInNewTab',
  redirect: 'redirect',
} as const;
export const externalApplicationStatuses = {
  enabled: 'enabled',
  disabled: 'disabled',
} as const;
